// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Draggable} from 'react-beautiful-dnd';

// Styled Components
const getBackgroundColor = ({active, index, isDragging, maxActive}) =>
  isDragging ? '#deebff' : active && index > maxActive - 1 ? '#ffd2d3' : '#FFFFFF';

const Container = styled.div`
  border: ${({isDragging}) => (isDragging ? '3px solid black;' : '1px solid darkgrey;')};
  1px solid lightgrey;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${props => getBackgroundColor(props)};
  box-shadow: ${({isDragging}) => (isDragging ? '2px 2px 1px #A5ADBA' : 'none')};
`;

const StorefrontItem = ({item, index, active, maxActive, onClick}) => (
  <Draggable draggableId={item.id} index={index}>
    {(provided, snapshot) => (
      <Container
        active={active}
        index={index}
        maxActive={maxActive}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        isDragging={snapshot.isDragging}
        ref={provided.innerRef}
        onClick={() => onClick(item)}
      >
        {item.name}
      </Container>
    )}
  </Draggable>
);

StorefrontItem.propTypes = {
  active: PropTypes.bool,
  index: PropTypes.number,
  item: PropTypes.object,
  maxActive: PropTypes.number,
  onClick: PropTypes.func,
};

export default StorefrontItem;
